import { Button } from "@/components/ui/button";
import { useRegisterSW } from "virtual:pwa-register/react";

export const PWABadge = () => {
  // check for updates every hour
  const period = 60 * 60 * 1000;

  const {
    offlineReady: [offlineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      if (period <= 0) return;
      if (r?.active?.state === "activated") {
        registerPeriodicSync(period, swUrl, r);
      } else if (r?.installing) {
        r.installing.addEventListener("statechange", (e) => {
          const sw = e.target as ServiceWorker;
          if (sw.state === "activated") registerPeriodicSync(period, swUrl, r);
        });
      }
    },
  });

  if (offlineReady) {
    console.log("useRegisterServiceWorker:offlineReady: true");
  }

  function close() {
    setNeedRefresh(false);
  }

  return (
    <div className="p-0 m-0 w-0 h-0" role="alert" aria-labelledby="toast-message">
      {needRefresh && (
        <div className="fixed right-0 bottom-0 m-4 p-3 border border-gray-400/50 rounded z-10 text-left shadow-md bg-white">
          <div className="mb-2">
            <span id="toast-message">A new version of 17reviews is available.</span>
          </div>
          <div className="flex gap-2">
            <Button onClick={() => updateServiceWorker(true)}>UPDATE</Button>
            <Button variant="outline" onClick={() => close()}>
              CLOSE
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * This function will register a periodic sync check every hour, you can modify the interval as needed.
 */
function registerPeriodicSync(period: number, swUrl: string, r: ServiceWorkerRegistration) {
  if (period <= 0) return;

  setInterval(async () => {
    if ("onLine" in navigator && !navigator.onLine) return;

    const resp = await fetch(swUrl, {
      cache: "no-store",
      headers: {
        cache: "no-store",
        "cache-control": "no-cache",
      },
    });

    if (resp.status === 200) await r.update();
  }, period);
}
